import type { DashboardFilterParams } from '@goldfishcode/kingmakerdata-api-sdk/libs/api/dashboard/models';

import type { Dashboard } from './model';

export const chartValueInitialize = {
  countyDropdown: [],
  precinctDropdown: [],
  selectControlCountyDropdown: [],
  selectControlPrecinctDropdown: [],
  ageRange: [],
  ageBracket: null,
  gender: null,
  est_party: null,
  voted: null,
  cityCouncil: null,
  // expected_remaining_voters_chart: null,  // Replaced by voter_history_chart (2026-03-12)
  voter_history_chart: null,
  tagDropdown: [],
  selectedTags: null,
  voterLikelihoodBar: null,
  preferredVotingStyleBar: null,
  contact_bar: null,
  contact_poll: null,
  projected_outcomes_chart: null,
  survey_chart: null,
};

export const filterParamInitialize: DashboardFilterParams = {
  age_bracket: '',
  est_party: '',
  projected_outcomes_chart: '',
  voted: '',
  contact_bar: '',
  contact_poll: '',
  // expected_remaining_voters_chart: '',  // Replaced by voter history filters (2026-03-12)
  vh_r_primaries: '',
  vh_d_primaries: '',
  vh_generals: '',
  vh_r_primaries_min: '',
  vh_d_primaries_min: '',
  vh_generals_min: '',
  voter_likelihood_bar: '',
  city_council: '',
  gender: '',
  polygon: undefined,
  preferred_voting_style_bar: '',
  select_control_party: '',
  select_control_vote_prediction: '',
  first_name: '',
  last_name: '',
};

export const initialState: Dashboard = {
  dashboardSettings: null,
  dashboardChartData: null,
  // Loading
  firstLoad: true,
  countLoading: 0,
  // Filter params
  dashboardFilterParams: filterParamInitialize,
  // Chart data from left to right
  ...chartValueInitialize,
  // State for actions
  isFilterChartsByChart: true,
  isClearFilter: false,
  isExportData: false,
  isExportDataClicked: false,
  isImportData: false,
  isImportDataClicked: false,
  isApplyRemoveFilter: false,
  isCreateBlockwalksWarning: false,
  isVisibleCharts: true,
  isSwitchCandidate: false,
  isLoadingChart: false,
  isLoadingDefault: false,
  // Storing tags
  tagConfig: {
    colors: [],
    icons: [],
  },
  tags: [],
  tagAndOr: 'AND',
  // Saving keys of changed filter params
  changedKeys: [],
  surveyAndOr: 'AND',

  // blockwalking or phone banking
  fieldOperationsQuery: {
    isLoading: false,
    searchValue: '',
    isBlockwalking: true,
  },
  fieldOperationsSelected: null,
  assignedToField: undefined,
  campaignBlocks: [],
  listActivity: [],
  activityQuery: {},
  questions: [],
  loadingQuestions: false,
  questionsBySurvey: {},
  surveyNames: [],
  loadingSurveyNames: false,
  selectedSurvey: [],
  lalVoterIds: [],
  isHouseholdView: false,
};
